import api from '../config/api';

const configuracionSsomaService = {
  async obtenerConfiguracion(empresaId) {
    try {
      const response = await api.get(`/configuracion-ssoma/empresa/${empresaId}`);
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Error al obtener configuración SSOMA',
      };
    }
  },

  async actualizarConfiguracion(empresaId, payload) {
    try {
      const body = typeof payload === 'boolean' ? { activo: payload } : payload;
      const response = await api.put(`/configuracion-ssoma/empresa/${empresaId}`, body);
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Error al actualizar configuración SSOMA',
        details: error.response?.data?.details,
      };
    }
  },

  async verificarEstado(empresaId) {
    try {
      const response = await api.get(`/configuracion-ssoma/empresa/${empresaId}/estado`);
      return response.data;
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Error al verificar estado SSOMA',
      };
    }
  },
};

export default configuracionSsomaService;
